import { render } from "./RemoteMontioringEventSidebarContent.vue?vue&type=template&id=61530a8d&ts=true"
import script from "./RemoteMontioringEventSidebarContent.vue?vue&type=script&lang=ts"
export * from "./RemoteMontioringEventSidebarContent.vue?vue&type=script&lang=ts"

import "./RemoteMontioringEventSidebarContent.vue?vue&type=style&index=0&id=61530a8d&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__